var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58003 2.9222C5.20075 3.55147 2.59664 6.3854 2.31664 9.87502H6.06857C6.23622 7.36175 7.10994 4.95274 8.58003 2.9222ZM10 1.54169C5.05245 1.54169 1.04167 5.55247 1.04167 10.5C1.04167 15.4476 5.05245 19.4584 10 19.4584C14.9476 19.4584 18.9583 15.4476 18.9583 10.5C18.9583 5.55247 14.9476 1.54169 10 1.54169ZM11.42 2.9222C12.8901 4.95273 13.7638 7.36176 13.9314 9.87502H17.6834C17.4034 6.38539 14.7992 3.55147 11.42 2.9222ZM12.6784 9.87502C12.4964 7.40357 11.5612 5.04712 10 3.12396C8.43882 5.04712 7.50359 7.40357 7.32164 9.87502H12.6784ZM7.32164 11.125H12.6784C12.4964 13.5965 11.5612 15.9529 10 17.8761C8.43882 15.9529 7.50359 13.5965 7.32164 11.125ZM6.06857 11.125H2.31664C2.59664 14.6146 5.20075 17.4486 8.58003 18.0778C7.10995 16.0473 6.23622 13.6383 6.06857 11.125ZM11.42 18.0778C12.8901 16.0473 13.7638 13.6383 13.9314 11.125H17.6834C17.4034 14.6146 14.7992 17.4486 11.42 18.0778Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.922351082dcbea3b1bffbff51f35e386.svg";
export { ForwardRef as ReactComponent };